// A picker and its upload share one absolute deadline. Check the clock on resume too:
// WebViews may suspend timers while the system camera is in front.
const MAX_HOLD_MS = 180000;
let current = null;
export const expireTabletLock = () => {
  if (!current || Date.now() < current.deadline) return false;
  if (!current.expired) {
    current.expired = true;
    window.dispatchEvent(new Event("cc-tablet-session-ended"));
  }
  return true;
};
export const holdTabletLock = () => {
  if (expireTabletLock()) return null;
  if (!current) current = { deadline: Date.now() + MAX_HOLD_MS, expired: false };
  return current;
};
export const isCurrentTabletHold = (lease) =>
  !!lease && current === lease && !expireTabletLock() && !lease.expired;
export const releaseTabletLock = (lease) => {
  if (current !== lease || !lease) return;
  const expired = expireTabletLock();
  current = null;
  if (!expired) window.dispatchEvent(new Event("cc-tablet-activity"));
};
export const resetTabletHold = () => { current = null; };
export const isTabletLockHeld = () => !!current && !expireTabletLock();
